<template>
  <div>
    <img :src="src" :alt="alt" @click="clickImage()">
    <b-modal :active.sync="modalActive" :width="width" scroll="keep">
      <!-- Ratio (such as is-3by2) is needed if the ClickableImage is already included in a tag with a ratio set. -->
      <p class="image" :class="ratio">
        <img :src="src" :alt="alt">
      </p>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: ['src', 'alt', 'ratio'],
  name: "ClickableImage",
  methods: {
    clickImage() {
      this.modalActive = true
    }
  },
  data() {
    return {
      modalActive: false,
    }
  },
  computed: {
    width() {
      let image = new Image();
      image.src = this.src;
      return image.width > 960 ? 960 : image.width;
    }
  }
}
</script>

<style scoped>

</style>